<template>
  <div>
    <!-- 浮层 -->
    <div class="province-select">
      <img class="province-icon" src="../../../assets/imgs/location_icon.png" />
      <div class="province-title">常住地</div>
      <div class="province-content" @click="provinceOpen = true">
        {{ provinceStr
        }}<img
          class="province-down-icon"
          src="../../../assets/imgs/down-icon.png"
        />
      </div>
    </div>
    <!-- 省份选择 -->
    <CommonDialog
      v-model="provinceOpen"
      title="选择常住地"
      class="province-dialog"
      :hideClose="parseInt(provinceCode) === 0"
    >
      <div class="province-dialog-label">
        连续居住满 3~6 个月及以上的地区<br />（部分签证需提供有效居住证件）
      </div>
      <div class="province-box-list">
        <div
          class="province-box"
          @click="provinceSelect(key)"
          :class="{ active: provinceCode === key }"
          v-for="(province, key) in provinceObj"
          :key="province"
        >
          {{ province }}
        </div>
      </div>
    </CommonDialog>
  </div>
</template>
<script>
import pcdService from '../../../services/pcdService';
import CommonDialog from './common-dialog';

export default {
  name: 'province-select',
  components: {
    CommonDialog,
  },
  data() {
    return {
      provinceOpen: this.visible,
      provinceObj: {},
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    provinceCode: {
      type: String,
      default: '0',
    },
  },
  created() {
    pcdService.getPcd().then((res) => {
      this.provinceObj = res[86];
    });
  },
  computed: {
    provinceStr() {
      if (this.provinceCode === '0') {
        return '请选择';
      }
      return this.provinceObj[this.provinceCode];
    },
  },
  methods: {
    provinceSelect(code) {
      this.$emit('on-select-province', code);
      this.provinceOpen = false;
    },
  },
  watch: {
    provinceOpen(newVal) {
      this.$emit('update:visible', newVal);
    },
    visible(newVal) {
      this.provinceOpen = newVal;
    },
  },
};
</script>
<style lang="less" scoped>
.province-dialog {
  .province-box-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  .province-box {
    height: 0.34rem;
    width: 0.59rem;
    line-height: 0.33rem;
    text-align: center;
    border: 1px solid #f0f0f0;
    margin-right: 0.1rem;
    margin-bottom: 0.1rem;
    border-radius: 0.03rem;
    color: #6f6f6f;
    &:nth-of-type(4n) {
      margin-right: 0;
    }
    &.active {
      color: #ff5a60;
      border-color: #ff5a60;
    }
  }
  .province-dialog-label {
    width: 100%;
    text-align: center;
    font-size: 0.13rem;
    line-height: 1.5;
    color: #6f6f6f;
    margin-bottom: 0.2rem;
  }
}
.province-select {
  width: 100%;
  height: 0.43rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 500;
  .province-icon {
    width: 0.12rem;
    height: 0.16rem;
    margin-right: 0.065rem;
  }
  .province-title {
    color: #6f6f6f;
    font-size: 0.14rem;
    margin-right: 0.16rem;
  }
  .province-content {
    color: #444444;
    font-size: 0.14rem;
    display: flex;
    align-items: center;
  }
  .province-down-icon {
    width: 0.09rem;
    height: 0.05rem;
    margin-left: 0.05rem;
  }
}
</style>
<style lang="less">
.province-dialog {
  .dialog-content {
    height: 2.5rem;
    overflow: auto;
    padding-bottom: 0.15rem !important;
    padding-top: 0.1rem !important;
  }
}
</style>
